// Local dependencies
import { Logo, ServiceStatus, ServiceTypename } from '../../../utils/types';

export interface Category {
  code: string;
  id: string;
  lastDisabledDate: string;
  lastEnabledDate: string;
  logo: Logo;
  name_en: string;
  name_ky: string;
  name_ru: string;
  name_tr: string;
  popularityScore: number;
  rboCode: string;
  registrationDate: string;
  slug: string;
  status: ServiceStatus;
  statusMessage: string;
  tags: string[];
  __typename: ServiceTypename;
}

export interface GetCategoryInput {
  id: string;
}

export interface GetCategoryState {
  loading: boolean;
  error: Error | null;
  category: Category;
}

export enum GetCategoryActionType {
  GET_CATEGORY = 'GET_CATEGORY',
  GET_CATEGORY_SUCCESS = 'GET_CATEGORY_SUCCESS',
  GET_CATEGORY_ERROR = 'GET_CATEGORY_ERROR',
}

export interface GetCategory {
  type: GetCategoryActionType.GET_CATEGORY;
  input: GetCategoryInput;
}

export interface GetCategorySuccess {
  type: GetCategoryActionType.GET_CATEGORY_SUCCESS;
  category: Category;
}

export interface GetCategoryError {
  type: GetCategoryActionType.GET_CATEGORY_ERROR;
  error: Error;
}

export type GetCategoryAction = GetCategory | GetCategorySuccess | GetCategoryError;
